import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeToLabel',
  standalone: true,
})
export class SnakeToLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return '';
    }

    // Replace underscores and hyphens with spaces
    const withSpaces = trimmed.replace(/[_-]+/g, ' ');

    // Split into words, lowercase them, and capitalize first letter of each
    return withSpaces
      .split(' ')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}

